"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MIGRATION_005 = void 0;
const MIGRATION_005_SQL = `\
-- Migration 005 (server only): file uploads.

CREATE TABLE IF NOT EXISTS omni_files (
  id TEXT PRIMARY KEY,
  tenant_id TEXT NOT NULL,
  owner_user_id TEXT NOT NULL,
  original_name TEXT NOT NULL,
  mime TEXT NOT NULL,
  size INTEGER NOT NULL,
  state TEXT NOT NULL CHECK(state IN ('local','uploading','remote','failed')),
  local_path TEXT,
  remote_url TEXT,
  bedrock_key TEXT,
  created_at BIGINT  NOT NULL,
  promoted_at BIGINT,
  purged_at BIGINT,
  error_message TEXT
);
CREATE INDEX IF NOT EXISTS idx_omni_files_owner ON omni_files(tenant_id, owner_user_id, created_at DESC);
`;
exports.MIGRATION_005 = {
    id: '005_files',
    version: 5,
    name: 'file uploads',
    side: 'server',
    sql: MIGRATION_005_SQL,
};
//# sourceMappingURL=005_files.js.map